export default "__VITE_ASSET__D8d68uNn__"